module.exports = __webpack_public_path__ + "img/biter-run-mask1.df83b406.png";